var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighlights(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1254 1254",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7f4ce7;\n      }\n\n      .cls-2 {\n        fill: #fcfbfd;\n      }\n\n      .cls-3 {\n        fill: #7f4be7;\n      }\n\n      .cls-4 {\n        fill: #7f4ce6;\n      }\n\n      .cls-5 {\n        fill: #7f4ce8;\n      }\n\n      .cls-6 {\n        fill: #804ce8;\n      }\n\n      .cls-7 {\n        fill: #804de7;\n      }\n\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 897.31,
    y: 840.91,
    width: 34.11,
    height: 273.5,
    transform: "translate(-423.38 929.57) rotate(-44.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 960.7,
    y: 612.28,
    width: 33.57,
    height: 214.17,
    transform: "translate(257.49 1696.39) rotate(-89.96)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "574.42 797.42 505.27 867.56 431.86 706.78 510.83 626.89 572.98 563.99 625.07 511.16 642.27 493.42 801.68 566.31 762.91 605.91 713.78 655.83 645.83 724.83 574.42 797.42"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 546.52,
    y: 1024.35,
    width: 217.08,
    height: 32.36,
    transform: "translate(-385.52 1695.51) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M678.95,790.18c-13.81-2.24-24.69-11.24-31.1-22.94l56.21-56.57c11.89,7.28,20.5,18.52,22.76,32.35,2.17,13.28-2.26,26.45-11.4,35.77-9.1,9.29-22.41,13.67-36.47,11.39Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M217.69,437.45c-4.69-45.83,11.4-90.17,44.65-122.48,2.19,29.37-4.06,53.21,8.18,80.42,21.58,47.95,80.45,66.59,125.95,39.95,26.08-15.27,41.8-42.19,43.2-72.61l.36-65.25,175.9,175.72-169.35,171.18-34.47,35.12-73.16-73.47-83.75-85.09c-21.97-22.32-34.29-52.01-37.51-83.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M405.02,358.49c-.17,30.15-23.94,53.37-52.56,53.9s-53.1-21.96-54.8-51.54l-.03-255.78h107.42s-.03,253.42-.03,253.42ZM382.84,357.51c0-17.36-14.08-31.44-31.44-31.44s-31.44,14.08-31.44,31.44,14.08,31.44,31.44,31.44,31.44-14.08,31.44-31.44Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 351.39,
    cy: 357.51,
    r: 31.44
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlights);
export default __webpack_public_path__ + "static/media/highlights.a17d9507ad606f9b38de7214fdce83de.svg";
export { ForwardRef as ReactComponent };